
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/set-46/augments",
      function () {
        return require("private-next-pages/info/set-46/augments.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/set-46/augments"])
      });
    }
  